var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#3889FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9443 13.9275C17.9441 18.4051 17.9202 21.0065 17.8768 21.2833C17.7312 22.2133 17.1344 23.0391 16.2987 23.4671C15.8917 23.6755 15.7453 23.7139 15.2445 23.7435C14.7527 23.7726 14.591 23.7539 14.1973 23.6228C13.0932 23.2549 12.3142 22.2369 12.2271 21.0481C12.1369 19.8164 12.7689 18.7069 13.8689 18.1656C14.3339 17.9367 14.4097 17.9199 14.9803 17.9186C15.3171 17.9178 15.6724 17.9402 15.7699 17.9685L15.9472 18.0198V16.3562V14.6926L15.4477 14.6475C14.5756 14.5689 13.4954 14.766 12.5959 15.1681C10.1975 16.2403 8.70944 18.9337 9.04776 21.5903C9.37383 24.1509 11.1637 26.215 13.603 26.8434C14.4168 27.053 15.7498 27.0521 16.5271 26.8412C18.6793 26.2576 20.3258 24.5846 20.9268 22.3706C21.0611 21.876 21.0676 21.7013 21.1005 17.7369L21.1347 13.6172L21.5858 13.9225C22.1553 14.3079 22.9196 14.6806 23.5907 14.9002C24.1327 15.0777 25.2739 15.2796 25.7344 15.2796H26V13.6437V12.0078H25.7395C25.3547 12.0078 24.5398 11.8188 24.1025 11.6281C22.9972 11.146 21.9838 10.1265 21.5126 9.02244C21.3155 8.56078 21.1035 7.66097 21.1029 7.28378L21.1025 7H19.5237H17.9448L17.9443 13.9275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.74fc17c9.svg";
export { ForwardRef as ReactComponent };